export default __webpack_public_path__ + "177b6a3796bb30f8b9d070b18376c37e.webp";